import { useTranslation } from "react-i18next";

import LoadingCircle from "../../../../components/loadingCircle/LoadingCircle";
import { ITag } from "../../../../models/tag";
import "./YourDeliveriesCard.scss";

interface YourDeliveriesCardProps {
  tag: ITag;
  count: number;
  loading: boolean;
}

const YourDeliveriesCard = (props: YourDeliveriesCardProps) => {
  const { t } = useTranslation();
  const { tag, count, loading } = props;

  return (
    <div data-testid="your-deliveries-card" className="your-deliveries-card">
      <div className="your-deliveries-card-description">{t(tag.name)}</div>
      {loading ? (
        <LoadingCircle />
      ) : (
        <div
          data-testid="your-deliveries-card-count"
          className="your-deliveries-card-count"
        >
          {count}
        </div>
      )}
    </div>
  );
};
export default YourDeliveriesCard;
